export const PRODUCT_CARD = "product-card";
export const PRODUCT_CARD_PRODUCT_NAME = "productCard-name";
export const PRODUCT_CARD_TOKEN_ID = "productCard-tokenId";
export const PRODUCT_CARD_SWOOSH_HANDLE = "productCard-user";
